import React from 'react'
import Header from './components/Header.jsx'
import Footer from './components/Footers.jsx'

function App() {
  return (
    <div className="main">
      <Header />
      <Footer/>
    </div>
  );
}

export default App